module.exports = __webpack_public_path__ + "static/media/Image_OB_Notifications.57703733.png";